import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MonoLabel } from "../components/kit";
import { useAuth } from "../context/AuthContext";
import api, { formatApiErrorDetail } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");
  const { setUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.onboarding_completed ? "/app" : "/onboarding", { replace: true, state: { user: data } });
      } catch (err) {
        window.history.replaceState(null, "", window.location.pathname);
        setError(formatApiErrorDetail(err.response?.data?.detail) || "Google sign-in failed — try again.");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen dot-grid flex items-center justify-center px-4" data-testid="auth-callback">
      {error ? (
        <div className="card-soft p-8 max-w-md text-center">
          <p className="text-[14px] text-[#B4443C]" data-testid="auth-callback-error">{error}</p>
          <button
            className="mt-4 font-semibold text-[#181621] underline underline-offset-2 text-[13.5px]"
            onClick={() => { window.history.replaceState(null, "", "/auth"); window.location.href = "/auth"; }}
            data-testid="auth-callback-back-btn"
          >
            Back to sign in
          </button>
        </div>
      ) : (
        <MonoLabel>SIGNING YOU IN…</MonoLabel>
      )}
    </div>
  );
}
